import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78399515"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "readfurther__text" }
const _hoisted_2 = { class: "readfurther__title" }
const _hoisted_3 = { class: "readfurther__links" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_page_section = _resolveComponent("page-section")!

  return (_openBlock(), _createBlock(_component_page_section, {
    class: "readfurther",
    revealOnScroll: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, key) => {
          return (_openBlock(), _createElementBlock("a", {
            href: item.url,
            class: "readfurther__link",
            key: `readfurther-link-${key}`
          }, [
            _createTextVNode(_toDisplayString(item.title) + " ", 1),
            _createVNode(_component_Icon, {
              class: "readfurther__link_icon",
              type: "arrow-right"
            })
          ], 8, _hoisted_4))
        }), 128))
      ])
    ]),
    _: 1
  }))
}